<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <span class="footerDetail">
      © {{ new Date().getFullYear() }}
      <a href="https://triple-a.io" target="_blank" rel="noopener"
        >Triple A Technologies Pte. Ltd. (GST Reg No. 201717321C).</a
      >
      - All Rights Reserved
      <small>(v{{ version }})</small>
    </span>
    <span class="md:flex hidden items-center">
      <span>Cryptocurrency payment gateway</span>
    </span>
  </footer>
</template>

<script>
export default {
  name: 'the-footer',
  props: {
    classes: {
      type: String,
    },
  },
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      // No longer used because the legal entity has been hardcoded. Reason being:
      // (1) The naming of the SG legal entity stored in the database is not what we want reflected on FE; and
      // (2) GST Registration Number is only tied to our SG entity.
      // Leaving this here because we'll have to have a solution for this when we apply for VAT.
      legalEnity: this.$store.state.merchants[0].legal_entity,
    };
  },
};
</script>

<style scoped>
@media only screen and (min-width: 1200px) {
  .footerDetail {
    padding-left: 260px;
  }
}
</style>
